import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { CUISINE_TYPE_NODE_FRAGMENT } from '../fragments'

const REVERT_REPLACE_CUISINE_TYPE_MUTATION = gql`
  mutation revertReplaceCuisineType($replaceToken: String!) {
    revertReplaceCuisineType(replaceToken: $replaceToken) {
      results {
        ...CuisineTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${CUISINE_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default REVERT_REPLACE_CUISINE_TYPE_MUTATION
